import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './StripePaymentForm.css';

const StripePaymentForm = ({ 
  amount, 
  clientSecret, 
  metadata,
  onPaymentSuccess, 
  onPaymentError 
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Format amount for display
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const cardElement = elements.getElement(CardElement);
      
      const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            email: metadata.email
          },
        },
        receipt_email: metadata.email
      });

      if (error) {
        setError(error.message);
        onPaymentError(error.message);
      } else if (paymentIntent.status === 'succeeded') {
        onPaymentSuccess(paymentIntent);
      } else {
        setError(`Payment status: ${paymentIntent.status}`);
        onPaymentError(`Payment status: ${paymentIntent.status}`);
      }
    } catch (err) {
      console.error('Payment error:', err);
      setError('An unexpected error occurred. Please try again.');
      onPaymentError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
    hidePostalCode: true
  };

  return (
    <div className="payment-form-container">
      <h3>Complete Payment</h3>
      <div className="payment-amount">
        <span>Total Amount:</span>
        <span className="amount">{formattedAmount}</span>
      </div>
      
      <form onSubmit={handleSubmit} className="stripe-form">
        <div className="card-element-container">
          <label htmlFor="card-element">Credit or Debit Card</label>
          <CardElement id="card-element" options={cardElementOptions} />
        </div>
        
        {error && <div className="payment-error">{error}</div>}
        
        <button 
          type="submit" 
          disabled={!stripe || loading} 
          className="payment-button"
        >
          {loading ? 'Processing...' : 'Pay Now'}
        </button>
      </form>
      
      <div className="payment-security-notice">
        <div className="lock-icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 7H12V5C12 2.24 9.76 0 7 0C4.24 0 2 2.24 2 5V7H1C0.45 7 0 7.45 0 8V15C0 15.55 0.45 16 1 16H13C13.55 16 14 15.55 14 15V8C14 7.45 13.55 7 13 7ZM8 12C7.45 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.55 12 8 12ZM10.8 7H5.2V5C5.2 4.12 6.12 3.2 7 3.2C7.88 3.2 8.8 4.12 8.8 5V7Z" fill="#6B7280"/>
          </svg>
        </div>
        <span>Secure payment processed by Stripe</span>
      </div>
    </div>
  );
};

export default StripePaymentForm; 